module.exports = __webpack_public_path__ + "images/ds-is-icon-r-scroll.webp";